<template lang='pug'>
  span.copyable
    a(@click='copy' v-text='labelBefore' :class="copied ? 'hidden' : ''")
    span(v-if='copied' v-text='labelAfter')
</template>

<script>
import copy from 'copy-to-clipboard'
export default {
  name: 'Copyable',
  data() {return {
    copied: false
  }},
  props: {
    labelAfter: String,
    labelBefore: String,
    value: String
  },
  methods: {
    copy() {
      this.copied = copy(this.value)
    }
  }
}
</script>

<style scoped lang='stylus'>
.copyable
  position relative
  span
    position absolute
    left 0

a
  display inline-block
  text-decoration underline
  cursor pointer
  border-bottom 1.5px solid white
  transform-origin left
  transform scaleX(1)
  opacity 1
  &.hidden
    transition transform 300ms cubic-bezier(0.23, 1, 0.32, 1), opacity 450ms cubic-bezier(0.86, 0, 0.07, 1)
    opacity 0
    color white
    border-color black
    pointer-events none
    transform scaleX(0.52)
  @media (hover hover)
    &:hover
      text-decoration none
      border-color black
  @media (hover none)
    &:hover
      transform scaleX(1) translateY(-4px)
    &.hidden
      transform scaleX(0.52) translateY(-4px)
</style>
